import type { PlatformStatsData } from 'api/dist/routes/_public/platform-stats'

/**
 * Metadata for the lp-v3 "vision" section notification stack. The live VALUES come from the public
 * `/platform-stats` endpoint (see get-platform-stats-query) — `apiKey` selects each card's number
 * from that payload. There are NO placeholder/fallback numbers: if the endpoint is unavailable (e.g.
 * at build time before the first cron run) a card shows 0, never an invented figure. Labels/tooltips
 * are the real SEO copy and ship in the HTML.
 */
export type VisionStat = {
    id: string
    apiKey: keyof PlatformStatsData
    label: string
    info?: string
}

// "Autonomously working agents" + "Agents at work right now" hidden for relaunch — re-add as the
// first VISION_STATS_COLLAPSED entries (front of the stack) when product should show them again.
// Array order is [front…, fan…]: the first `VISION_STATS_COLLAPSED` cards sit solid at the bottom of
// the stack; the rest reverse-fan above. Desired expanded top→bottom = researched → built → reports.
export const VISION_STATS: VisionStat[] = [
    { id: 'ads-built', apiKey: 'adsBuiltLast24h', label: 'Ads built · last 24h' },
    { id: 'reports-7d', apiKey: 'reportsLast7d', label: 'Reports created · last 7d' },
    { id: 'ads-researched', apiKey: 'adsResearchedLast24h', label: 'Ads researched · last 24h' },
]

/** How many cards are visible in full in the collapsed (un-hovered) stack; the rest peek as a fan. */
export const VISION_STATS_COLLAPSED = 2
